<div class="bg-th-yellow mt-0 container-fluid" >

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> تعرفه سرویس مدرسه </span>

    </div>

</div>

<form [formGroup]="sourceModel" class="w-100 form rtl row gx-2 gy-2 px-2 px-md-5 mt-1">

    <div class="col-12 col-md-3" *ngIf="list_City.length > 0">

        <label class="col-sm-3 col-form-label">  شهر  </label>

        <!-- <i class="fa fa-chevron-down" aria-hidden="true"></i> -->

        <ng-container *ngIf="!editMode && !addMode">

            <div class="col">

                <custom-filter

                    [strValue]="''"

                    [strComment]="'strCityName'"
            
                    [stylesArray]="['padding-top: 10px']"
            
                    [str_Placeholder]="'نام شهر را جستجو کنید'"
            
                    [lst_Main]="list_City" 
            
                    [lst_SearchKey]="['strCityName']"
            
                    [isDisabled]="false"
                    
                    (hideOptions)="selectedCity($event)">
        
                </custom-filter>

                <!-- <input type="text" name="selectedCity" autocomplete="off" 

                (focus)="filteredCity = list_City"

                (blur)="hideCity_Option()"
                
                class="form-control" placeholder="نام شهر را جستجو کنید" 
                
                [(ngModel)]="searchT_City" [ngModelOptions]="{standalone: true}" (input)="filterCity()" />
          
                <ul class="list-group" style="max-height: 200px;overflow: auto;">
        
                    <li class="list-group-item pointer" *ngFor="let item of filteredCity" 
                    
                        [@fadeAnimation] (click)="selectedCity(item)">
                        
                        {{ item.strCityName }}
                    
                    </li>
                    
                </ul> -->
      
              </div>

        </ng-container>

        <ng-container *ngIf="editMode || addMode">

            <div class="col">

                <!-- <input type="search" name="selectedCity" autocomplete="off" class="form-control" placeholder="نام شهر را جستجو کنید"/> -->

                <custom-filter

                    [strValue]="''"

                    [strComment]="'strCityName'"
            
                    [stylesArray]="['padding-top: 10px']"
            
                    [str_Placeholder]="'نام شهر را جستجو کنید'"
            
                    [lst_Main]="list_City" 
            
                    [lst_SearchKey]="['strCityName']"
            
                    [isDisabled]="false"
                    
                    (hideOptions)="selectedCity($event)">
    
                </custom-filter>
          
              </div>

        </ng-container>

    </div>
    
    <div class="col-12 col-md-3">

        <label> سال </label>

        <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9]/g,'')" type="text" maxlength="4" formControlName="iYear" class="form-control" />

        <!-- <ng-persian-datepicker  [uiTheme]="'gray'" [timeEnable]="false"  [uiInitViewMode]="'year'"  [dateGregorianFormat]="'YYYY'" [uiHideAfterSelectDate]="true" [uiMonthView]="false"  [dateInitValue]="true" [dateFormat]="'jYYYY'" [uiTodayBtnEnable]="false">

            <input dir="ltr" type="text" maxlength="4" formControlName="iYear" class="form-control" />

        </ng-persian-datepicker> -->

    </div>

    <div class="col-12 col-md-auto d-flex align-items-end pb-1 justify-content-end " style="max-height: 6.5vh;">

        <button class="btn mx-md-2 px-5 btn-primary w-100 " type="button" (click)="searchFee()">جستجو</button>

    </div>
    
    <div class="col-12 col-md-auto d-flex align-items-end pb-1 justify-content-end " style="max-height: 6.5vh;">

        <button class="btn mx-md-2 px-5 btn-success w-100 " type="button" (click)="openModal()"> جدید </button>

    </div>

</form>

<main class="rtl px-2 px-md-5 pt-3">

    <span *ngIf="list_Result.length > 0"> تعداد <span class="text-danger fw-bold">{{list_Result.length | faNum}}</span> مورد یافت شد </span>

    <div class="row gx-2 mt-1 border border-2 ">

        <div class="col-12 p-3" [ngClass]="list_Result.length == 0 ? 'col-md-12' : 'col-md-10' ">

            <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">

        </div>

        <div *ngIf="list_Result.length > 0" class="col-12 col-md-2 text-end p-3">

            <button class="btn btn-success" (click)="exportExcel()">

                <span> خروجی اکسل </span>

                <i class="fa fa-file-excel-o mx-2" aria-hidden="true"></i>

            </button>

        </div>

        <div class="table-responsive" style="max-height: 83vh;">

            <table class="table table-striped" id="Export_Excel">

                <thead class="position-sticky top-0 bg-white">

                    <tr class="col-12 text-center">
    
                        <th> عملیات </th>

                        <th> شهر </th>

                        <th> سال </th>

                        <th> شهرداری  </th>

                        <th> آموزش و پرورش  </th>

                        <th> بیمه تامین اجتماعی  </th>

                        <th> پیمانکار  </th>
 
                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of list_Result">

                        <td class="col-1">

                            <i title="تعریف نوع خودرو " class="fa fa-car fa-lg bg-gray p-2 rounded text-success pointer" (click)="openModal(item,'addCar')" aria-hidden="true"></i>

                            <i title="ویرایش" class="fa fa-pencil-square mx-2 my-2 my-md-0 fa-lg bg-gray p-2 rounded text-primary pointer" (click)="openModal(item)" aria-hidden="true"></i>

                            <i title="حذف" class="fa fa-trash fa-lg bg-gray p-2 rounded text-danger pointer" (click)="removeFee(item)" aria-hidden="true"></i>


                        </td>

                        <td class="col-1">{{item.strCityName}}</td>

                        <td class="col-1">{{item.iYear | faNum}}</td>
                        
                        <td class="col-1">{{ ( item.fMuncPercent / 100 | percent ) | faNum }}</td>

                        <td class="col-1">{{ ( item.fEducationPercent / 100 | percent ) | faNum }}</td>

                        <td class="col-1">{{ ( item.fInsurancePercent / 100 | percent ) | faNum }}</td>
                        
                        <td class="col-1">{{ ( item.fCompanyPercent / 100 | percent ) | faNum }}</td>

                    </tr>

               </tbody>

            </table>

        </div>

    </div>

</main>

<div class="modal fade" id="service_Fee" tabindex="-1" aria-hidden="true" data-backdrop="false" data-bs-backdrop='static'>

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title">  {{editMode ? ' ویرایش تعرفه ' : ' افزودن تعرفه ' }}</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeFeeModal()"></button>


            </div>

            <div class="modal-body ">

                <form [formGroup]="sourceModel" class="rtl w-100 row gx-2 gy-2 gy-md-1">

                    <div class="col-12 col-md-6">

                        <label> سال </label>
                
                        <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9]/g,'')" type="text" maxlength="4" formControlName="iYear" class="form-control" />
                               
                    </div>

                    <div class="col-12 col-md-6">

                        <label style="z-index: 2;" class="col-sm-3 col-form-label"> نام شهر  </label>

                        <custom-filter *ngIf="bShowFilter"

                            [strValue]="searchT_City"
        
                            [strComment]="'strCityName'"
                    
                            [stylesArray]="['padding-top: 10px']"
                    
                            [str_Placeholder]="'نام شهر را جستجو کنید'"
                    
                            [lst_Main]="list_City" 
                    
                            [lst_SearchKey]="['strCityName']"
                    
                            [isDisabled]="false"
                            
                            (hideOptions)="selectedCity($event)">
            
                        </custom-filter>

                        <!-- <i class="fa fa-chevron-down" aria-hidden="true"></i>
                
                        <div class="col">
                
                          <input type="search" name="selectedCity" autocomplete="off" class="form-control" 

                            (focus)="filteredCity = list_City"

                            (blur)="hideCity_Option()"
                          
                            placeholder="نام شهر را جستجو کنید" [(ngModel)]="searchT_City"
                            
                            [ngModelOptions]="{standalone: true}" (input)="filterCity()" />
                    
                          <ul class="list-group" style="max-height: 200px;overflow: auto;">
                  
                              <li class="list-group-item pointer" *ngFor="let item of filteredCity" 
                              
                                    [@fadeAnimation] (click)="selectedCity(item)">
                                    
                                    {{ item.strCityName }}
                            
                              </li>
                              
                          </ul>
                
                        </div> -->
                
                    </div>

                    <div class="col-12 col-md-6">

                        <label> درصد شهرداری </label>
                
                        <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1') + '%' " type="text"  formControlName="fMuncPercent" class="form-control" />
                               
                    </div>

                    <div class="col-12 col-md-6">

                        <label> درصد آموزش و پرورش </label>
                
                        <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1') + '%' " type="text"  formControlName="fEducationPercent" class="form-control" />
                               
                    </div>

                    <div class="col-12 col-md-6">

                        <label> درصد بیمه تامین اجتمایی </label>
                
                        <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1') + '%' " type="text"  formControlName="fInsurancePercent" class="form-control" />
                               
                    </div>

                    <div class="col-12 col-md-6">

                        <label> درصد پیمانکار </label>
                
                        <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1') + '%' " type="text"  formControlName="fCompanyPercent" class="form-control" />
                               
                    </div>

                </form>

            </div>

            <div class="modal-footer">

                <div class="col-12 col-md-3 d-flex align-items-end pb-1 justify-content-end" style="max-height: 6.5vh;">

                    <button [ngClass]="editMode ? 'btn-primary' : 'btn-success'" class="btn mx-md-2 px-5 w-100 " type="button" (click)="newService_Fee()">  {{editMode ? ' ویرایش ' : ' ذخیره ' }}</button>
            
                </div>

            </div>


        </div>

    </div>

</div>

<div class="modal fade" id="addCar" tabindex="-1" aria-hidden="true" data-backdrop="false" data-bs-backdrop='static'>

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title">  {{editMode ? ' ویرایش تعرفه نوع خودرو  ' : ' تعرفه نوع خودرو  ' }}</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="editMode=false;bCarResult=true"></button>

            </div>

            <div class="modal-body ">

                <ng-container *ngIf="bCarResult">

                    <form class="rtl w-100 row gx-2 gy-2 gy-md-1">

                        <div class="col-12 col-md-10 p-0 p-md-3">
    
                            <input type="search" #search (input)="searchBy(search.value,'list_CarsFeeBaseType')" class="form-control" placeholder="جستجو کنید">
                
                        </div>
                
                        <div class="col-12 col-md-2 text-end d-flex align-items-center ">
                
                            <button class="w-100 btn btn-success" (click)="initAddMde()">
                
                                <span> افزودن </span>
                            
                            </button>
                
                        </div>
                
                    </form>
    
                    <div class="table-responsive border border-2  p-2" style="max-height: 83vh;">
    
                        <table class="table table-striped" id="Export_Excel">
            
                            <thead class="position-sticky top-0 bg-white">
            
                                <tr class="col-12 text-center">
                
                                    <th> عملیات </th>
            
                                    <th> نوع خودرو  </th>
            
                                    <th> مبلغ پایه  </th>
            
                                    <th> حداقل پیمایش  </th>
            
                                    <th> کرایه به ازاء هر کیلومتر بیشتر  </th>
                     
                                </tr>
            
                            </thead>
            
                            <tbody>
            
                                <tr class="col-12 text-center" *ngFor="let item of list_CarsFeeBaseType;trackBy:trackByType">
            
                                    <td class="col-1">
                    
                                        <i title="ویرایش" class="fa fa-pencil-square mx-2 fa-lg bg-gray p-2 rounded text-primary pointer" (click)="editFeeBaseCar(item)" aria-hidden="true"></i>
            
                                        <i title="حذف" class="fa fa-trash fa-lg mt-1 mt-md-0 bg-gray p-2 rounded text-danger pointer" (click)="removeFee(item)" aria-hidden="true"></i>
            
                                    </td>
            
                                    <td class="col-1">{{item?.strMobileType_strComment}}</td>
    
                                    <td class="col-1">{{item?.iBaseCost.toLocaleString() + ' ریال ' | faNum}}</td>
    
                                    <td class="col-1">{{item?.tiMinKM.toLocaleString() + ' کیلومتر ' | faNum}}</td>
                                    
                                    <td class="col-1">{{item?.iCostPerKM.toLocaleString() + ' ریال ' | faNum}}</td>
            
    
                                </tr>
            
                           </tbody>
            
                        </table>
            
                    </div>

                </ng-container>

                <ng-container *ngIf="!bCarResult">

                    <form [formGroup]="feeBaseCar" class="rtl w-100 row gx-2 gy-2 gy-md-1">

                        <div class="col-12 col-md-6">

                            <label> نوع خودرو </label>

                            <select class="form-control" formControlName="tiMobileType">

                                <option *ngFor="let item of list_CarType" value="{{item.tiMobileType}}">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <div class="col-12 col-md-6">

                            <label> مبلغ پایه ( ریال ) </label>
                    
                            <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9]/g,'')" type="text" formControlName="iBaseCost" class="form-control" />
                                       
                        </div>

                        <div class="col-12 col-md-6">

                            <label> حداقل پیمایش ( km ) </label>
                    
                            <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9]/g,'');if(this.value < 1) this.value = 1; if(this.value > 255) this.value = 255;" type="text" formControlName="tiMinKM"  class="form-control" />
                                       
                        </div>

                        <div class="col-12 col-md-6">

                            <label> کرایه به ازای هر کیلومتر بیشتر ( ریال )  </label>
                    
                            <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9]/g,'')" type="text" formControlName="iCostPerKM" class="form-control" />
                                       
                        </div>

                    </form>

                </ng-container>

            </div>

            <div class="modal-footer">

                <ng-container *ngIf="!bCarResult">

                    <div class="col-12 col-md-3 d-flex align-items-end pb-1 justify-content-end" style="max-height: 6.5vh;">

                        <button [ngClass]="editMode ? 'btn-primary' : 'btn-success'" class="btn mx-md-2 px-5 w-100" type="button" (click)="addNewFeeBaseCar()">  {{editMode ? ' ویرایش ' : ' ذخیره ' }}</button>

                        <button class="btn btn-danger mx-md-2 px-5 w-100 " type="button" (click)="bCarResult = true"> بازگشت </button>
                
                    </div>

                </ng-container>

            </div>


        </div>

    </div>

</div>